const applyToggle = document.getElementById('ready-to-apply-block__toggle');
const applyContent = document.getElementById('ready-to-apply-block__content');

function updateContentVisibility() {
  if (window.innerWidth > 880) {
    applyContent.style.display = 'block';
    applyToggle.style.display = 'none';
  } else {
    applyToggle.style.display = 'inline-flex';
    const isExpanded = applyToggle.getAttribute('aria-expanded') === 'true';
    applyContent.style.display = isExpanded ? 'block' : 'none';
  }
}

if (applyToggle) {
  applyToggle.addEventListener('click', () => {
    const isExpanded = applyToggle.getAttribute('aria-expanded') === 'true';
    applyToggle.setAttribute('aria-expanded', !isExpanded);
    applyContent.style.display = isExpanded ? 'none' : 'block';
    applyToggle.classList.toggle('usa-button--toggle-up', isExpanded);
    applyToggle.classList.toggle('usa-button--toggle-down', !isExpanded);
  });

  window.addEventListener('resize', updateContentVisibility);
  window.addEventListener('load', updateContentVisibility);
}
